import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogActions } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-prompt',
  templateUrl: './dialog-prompt.component.html',
  styleUrls: ['./dialog-prompt.component.scss']
})
export class DialogPromptComponent implements OnInit {
  public prompt: string;
  public message: string;
  public dialogRef: MatDialogRef<DialogPromptComponent>;

  constructor(
    public dialog: MatDialog) { }

  ngOnInit() {
  }

  doResult(value: string): void {
    this.dialogRef.close(value);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  show(prompt: string, message: string, options: any) {
    this.prompt = prompt;
    this.message = message;
    return new Promise((resolve, reject) => {
      this.dialogRef = this.dialog.open(DialogPromptComponent, {
        panelClass: 'flush-dialog'
      });
      this.dialogRef.afterClosed().subscribe(result => {
        resolve(result);
      });
    });
  }
}
